import PrismicPage from 'utils/prismic/PrismicPage';
import React from 'react';

const AboutPage = () => <PrismicPage pageName="about_page" title="About" />;

export default AboutPage;
